export default {
  signature: {
    title: 'Dados da Assinatura',
    signatureDate: 'Data da assinatura',
    issuer: 'Emissor do certificado',
    organization: 'Organização',
    serialNumber: 'Número de série',
    validity: 'Validade',
    to: ' a '
  }
}